export * from './lucky-six.component';